import { render, staticRenderFns } from "./product_description.vue?vue&type=template&id=1cc19afb&"
import script from "./product_description.vue?vue&type=script&lang=js&"
export * from "./product_description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports